import React from 'react';
import { IStatistic } from '../../models/statistic';
import { H3, P } from '../text';

interface IStatisticsRowProps {
	statistics: IStatistic[];
	className?: string;
	hasBgcolor?: boolean;
	additionalContent?: boolean;
}

export const StatisticsRow: React.FC<IStatisticsRowProps> = ({
	statistics,
	className = '',
	hasBgcolor = false,
	additionalContent = false,
}) => {
	if (!statistics || statistics.length === 0) {
		return null;
	}

	return (
		<div className={`${hasBgcolor ? 'bg-[#1d2330]' : 'bg-white'} bottom-1 border-gray-400 py-12 ${className}`}>
			<div className="container mx-auto px-4 max-w-7xl">
				{additionalContent && (
					<>
						<H3 className="text-white pt-12 text-center ">Onze cijfers spreken voor zich</H3>
						<P className="text-white opacity-25 text-center mb-8 py-4">
							De Keuken Kampioen Divisie bereikt wekelijks miljoenen voetballiefhebbers via diverse
							kanalen.
						</P>
					</>
				)}
				<div className="grid grid-cols-2 md:grid-cols-4 gap-8">
					{statistics.map((stat, index) => (
						<StatisticCard key={index} statistic={stat} hasBgcolor={hasBgcolor} />
					))}
				</div>
			</div>
		</div>
	);
};

interface IStatisticCardProps {
	statistic: IStatistic;
	hasBgcolor?: boolean;
}

const StatisticCard: React.FC<IStatisticCardProps> = ({ statistic, hasBgcolor = false }) => {
	const displayValue = statistic.value || '—';

	return (
		<div className="text-center">
			<div className={`text-4xl md:text-5xl font-bold mb-2 ${hasBgcolor ? 'text-white' : 'text-black-600'}`}>
				{displayValue}
			</div>
			<P className={hasBgcolor ? 'text-white' : 'text-black-600'}>{statistic.label}</P>
		</div>
	);
};

export default StatisticsRow;
